import {
    BRIGHT_UID,
    CREDIPLATA_UID,
    ENERGIA_REAL_UID,
    KAM_UID,
    RED_GIRASOL_UID,
    SERFIMEX_UID,
} from 'common/constants';

import financialBright from './Bright/config';
import financialCrediplata from './Crediplata/config';
import financialDefault from './Default/config';
import financialEnergiaReal from './EnergiaReal/config';
import financialKAM from './KAM/config';
import financialRedGirasol from './RedGirasol/config';
import financialSerfimex from './Serfimex/config';

/**
 * Obtiene la configuración del partner
 * Prioriza las configuraciones nuevas (migradas) sobre las legacy
 * @param {string} financierId - ID del financier
 * @returns {Object} Configuración del partner
 */
export default (financierId) => {
    const configs = {
        [BRIGHT_UID]: financialBright,
        [CREDIPLATA_UID]: financialCrediplata,
        [ENERGIA_REAL_UID]: financialEnergiaReal,
        [KAM_UID]: financialKAM,
        [RED_GIRASOL_UID]: financialRedGirasol,
        [SERFIMEX_UID]: financialSerfimex,
    };

    return configs[financierId] || financialDefault;
};
